module.exports = __webpack_public_path__ + "img/chris_g_27.80b49f80.jpg";